async function getAccountInfo(metaAddress) {
  let response = await fetch(metaAddress, {
    method: "GET",
  });

  let resData = await response.json();
  return resData;
}

export default async function main(metaAddress) {
  let candyMachineConfig = await getAccountInfo(metaAddress);
  let item = candyMachineConfig;


  return item;
}

if (require.main) main(process.argv.slice(2)).catch(console.error);
